import { useMemo } from 'react';
import { useTenant } from '../context/TenantContext';
import { vocab } from '../utils/publicProfile';

/**
 * Vertical vocabulary for the CURRENT club, driven by Club.clubType (resolved by TenantContext).
 * One helper, used everywhere — admin + trainer portals route their user-facing role/session
 * words through this so a gym reads "Members", a taekwondo club reads "Students", etc.
 *
 *   const v = useClubVocab();
 *   <h1>{v.members}</h1>          // "Students" | "Members"
 *   <button>Add {v.member}</button>
 *
 * Falls back to the taekwondo/Student set when the club isn't resolved yet, so wording is
 * stable during load and byte-identical to today for existing clubs.
 */
export default function useClubVocab() {
  const { club } = useTenant() || {};
  return useMemo(() => vocab(club?.clubType), [club?.clubType]);
}
